import React from "react";
import {
  totalQty,
  totalPriceProduct,
  comercialQuantity,
  totalComercialPrice,
  totalPriceObraEstimativa,
  totalPrice,
  totalPriceComercial,
  totalPriceAlt,
  totalPriceComercialAlt
} from "../../TableCalculations";

const rowPDF = props =>
  props.products.map(p => (
    <tr>
      <td>{p.prod.unit}</td>
      <td>{p.prod.description}</td>
      <td>{p.m2qty}</td>
      <td>{totalQty(p.m2qty, props.waste, props.m2).toFixed(2)}</td>
      <td>${" "}{p.prod.pricem2}</td>
      <td>
        ${" "}
        {totalPriceProduct(
          p.m2qty,
          props.waste,
          props.m2,
          p.prod.pricem2
        ).toFixed(2)}
      </td>
      <td>
        {Math.ceil(
          comercialQuantity(p.m2qty, props.waste, props.m2, p.prod.sup)
        )}
        {" " + p.prod.packaging}
      </td>
      <td>
        ${" "}
        {totalComercialPrice(
          p.m2qty,
          props.waste,
          props.m2,
          p.prod.sup,
          p.prod.priceud
        ).toFixed(2)}
      </td>
    </tr>
  ));

export default rowPDF;
